import { Location } from 'history'
import { parse } from 'query-string'

export default function getCorporatePartnerId(location: Location) {
  const query = parse(location.search)

  const corporatePartnerId = Array.isArray(query?.corporatePartnerId)
    ? query.corporatePartnerId[0]
    : query?.corporatePartnerId

  return corporatePartnerId
}
